// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app {\n  width: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #333333;\n  font-family: 'PingFang SC', '微软雅黑', Arial, sans-serif !important;\n}\n.demo-spin-icon-load {\n  animation: ani-demo-spin 1s linear infinite;\n}\na {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
